export default __webpack_public_path__ + "static/media/at (6).2040f147.jpg";